/**
 * How It Works section with tabs for renters and providers
 */

import React, { useState } from 'react';
import classNames from 'classnames';

import css from './HowItWorksSection.module.css';

const HowItWorksSection = ({ onBrowse, onListKit }) => {
  const [activeTab, setActiveTab] = useState('renters');

  const rentersSteps = [
    {
      number: 1,
      icon: '🔍',
      title: 'Browse & Discover',
      description: 'Find curated party kits for your occasion, date, and location. Filter by occasion, services, or budget.'
    },
    {
      number: 2,
      icon: '📦',
      title: 'Reserve & Customize',
      description: 'Book your kit and pick a service level: self-pickup, delivery, or full service (your host delivers, sets up, and breaks down). Connect with your host about timing and special requests.'
    },
    {
      number: 3,
      icon: '🎉',
      title: 'Celebrate & Return',
      description: 'Throw an amazing party. After your event, return your kit in good condition and start planning your next celebration.'
    }
  ];

  const providersSteps = [
    {
      number: 1,
      icon: '📸',
      title: 'Apply & List',
      description: 'Submit your kits for review. Approved hosts join a curated marketplace and choose how they fulfill each kit: self-pickup, delivery, or full service setup.'
    },
    {
      number: 2,
      icon: '💬',
      title: 'Get Booked',
      description: 'Customers discover your kits, book directly, and pay through Merrily. We handle payments, deposits, and customer support.'
    },
    {
      number: 3,
      icon: '💰',
      title: 'Earn & Grow',
      description: 'Your kits work for you. Each rental brings income, and the more you list, the more you earn.'
    }
  ];

  const activeSteps = activeTab === 'renters' ? rentersSteps : providersSteps;

  return (
    <section className={css.root} id="how-it-works">
      <div className={css.container}>

        <div className={css.header}>
          <h2 className={css.title}>How It Works</h2>
          
          <div className={css.tabs}>
            <button
              className={classNames(css.tab, { [css.active]: activeTab === 'renters' })}
              onClick={() => setActiveTab('renters')}
            >
              For Renters
            </button>
            <button
              className={classNames(css.tab, { [css.active]: activeTab === 'providers' })}
              onClick={() => setActiveTab('providers')}
            >
              For Hosts
            </button>
          </div>
        </div>

        <div className={css.stepsContainer}>
          <div className={css.steps}>
            {activeSteps.map((step, index) => (
              <div key={step.number} className={css.step}>
                <div className={css.stepHeader}>
                  <div className={css.stepNumber}>{step.number}</div>
                </div>
                
                <h3 className={css.stepTitle}>{step.title}</h3>
                <p className={css.stepDescription}>{step.description}</p>
                
                {/* Connection line to next step */}
                {index < activeSteps.length - 1 && (
                  <div className={css.connectionLine}></div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className={css.cta}>
          {activeTab === 'renters' ? (
            <button className={css.ctaButton} onClick={onBrowse}>
              Browse Party Kits
            </button>
          ) : (
            <button className={css.ctaButton} onClick={onListKit}>
              List Your Party Supplies
            </button>
          )}
        </div>

      </div>
    </section>
  );
};

export default HowItWorksSection;